import {Modal} from "bootstrap";

// noinspection JSUnusedGlobalSymbols
export default function () {
    let isConfirmed = false;

    $(function () {
        const $simulatorTemplates = $('#simulator-templates');
        const $container = $simulatorTemplates.closest('.form-group');
        $container.addClass('simulator-templates-container'); // Add class for styling

        if ($simulatorTemplates.children().length === 0) {
            $container.hide(); // Hide container if no templates are available
        }

        $('form:not(.survey-page-form) button[type="submit"]').on('click', function (e) {
            const modal = getModal();
            const submitButton: HTMLElement = this;
            if (modal && !isConfirmed) {
                e.preventDefault();
                handleModal(modal, submitButton);
            } else {
                submit(submitButton);
            }
        });
    });

    /**
     * Submit all selected templates as one hidden input, for easier server handling.
     *
     * Example:
     * <input type="checkbox" name="100-0" value="1">
     * <input type="checkbox" name="100-1" value="1">
     *
     * The above two fiels result in the following:
     * <input type="hidden" name="SimulatorTemplates" value="100-0,100-1" />
     */
    function submit(submitButton: HTMLElement): void {
        const name = $('#simulator-templates').data('element-id');
        const value = getSelectedTemplateIDs().join(',')
        $(submitButton).before(
            $(`<input type="hidden" name="${name}" value="${value}" />`)
        );
    }

    function getSelectedTemplateIDs(): string[] {
        let templateIDs: string[] = [];
        $('#simulator-templates input:checked').each(function () {
            templateIDs.push($(this).attr('name'))
        });
        return templateIDs;
    }

    /**
     * Show modal and wait for confirmation before finally submitting the form.
     */
    function handleModal(modal: Modal, submitButton: HTMLElement): void {
        modal.show();
        $('#simulator-templates-modal .confirm-btn').on('click', function (e) {
            e.preventDefault();
            isConfirmed = true;
            $(submitButton).trigger('click');
        });
    }

    function getModal(): Modal | null {
        const modalElement = document.getElementById('simulator-templates-modal');
        if (modalElement) {
            return Modal.getOrCreateInstance(modalElement);
        }
        return null;
    }
}

